import axios from 'axios'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASEURL
})

api.defaults.headers.common['Content-Type'] = "application/json";

export default api;